<template>
    <div id="wrapper">
        <Top></Top>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">SESサービス</h2>
                    </div>
                </div>
            </div>
        </section>
        <section id="content">
            <div class="container">
                <div class="about">
                    <section class="features">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div><h2>システムエンジニアリングサービス（SES）</h2>
                                    法令遵守はもちろん、派遣社員のキャリア形成やより良い労働環境の確保、派遣先でのトラブル予防など、安心できるサービスをお約束いたします。<br>
                                    幅広いお仕事を用意しており、今までの経験が十分に活かせるお仕事を提供することができます。</div>
                                    <br>
                                </div>
                            </div>
                            <div class="row">         
                                <div class="col-md-6">
                                <div class="features-item">
                                    <div class="features">
                                    <div class="icon">
                                    <i class="icon-info-blocks fa fa-star"></i>
                                    </div>
                                    <div class="features-content">
                                        <h3>高効率化の体制構築</h3>
                                        <p>プロジェクトの増員・減員を伴って、柔軟な開発体制を構築するのが可能になります。効率的で合理的なコスト削減するのを目標となります。</p>
                                    </div>
                                    </div>
                                    <div class="features">
                                    <div class="icon">
                                        <i class="icon-info-blocks fa fa-star"></i>
                                    </div>
                                    <div class="features-content">
                                        <h3>スキルが高い人材のご提供</h3>
                                        <p>特定分野のシステム開発や保守などに対して、専門人材を調達することで、教育期間は不要となり、高い専門性が必要とされる業務においても、即戦力が期待できます。</p>
                                    </div>
                                    </div>
                                    <div class="features">
                                    <div class="icon">
                                        <i class="icon-info-blocks fa fa-star"></i>
                                    </div>
                                    <div class="features-content">
                                        <h3>業務管理の負荷軽減</h3>
                                        <p>人員の採用、教育、業務管理などは当社で行うため、お客様の業務管理に関する負担を大幅に軽減し、管理リソースをコア業務に集中させる可能になります。</p>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                <div class="col-md-5">
                                <img class="img-responsive" src="../assets/img/ses1.jpg" alt="">
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="row">
                        <div class="col-md-4">
                            <!-- Heading and para -->
                            <div class="block-heading-two">
                                <h3><span>我々の強み</span></h3>
                            </div>
                            <p>先端IT技術で、お客様の要望に応じて、最適なソリューションを提供いたします。
                            <br><br>豊かな社員研修制度で、先端技術をお客様に提供できるように、常に全社のスキルアップを努力しています。
                            <br><br>いつでも、諦めずに誠心誠意、全力で乗り越えるように遂行します。</p>
                        </div>
                        
                        <div class="col-md-4">
                            <div class="block-heading-two">
                                <h3><span>当社経験者構成</span></h3>
                            </div>								
                            <h6>3年以下</h6>
                            <div class="progress pb-sm">
                              <!-- White color (progress-bar-white) -->
                              <div class="progress-bar progress-bar-red" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 20%">
                                 <span class="sr-only">40% Complete (success)</span>
                              </div>
                            </div>
                            <h6>3年～5年</h6>
                            <div class="progress pb-sm">
                              <div class="progress-bar progress-bar-green" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 65%">
                                 <span class="sr-only">40% Complete (success)</span>
                              </div>
                            </div>
                            <h6>5年～10年</h6>
                            <div class="progress pb-sm">
                              <div class="progress-bar progress-bar-lblue" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">
                                 <span class="sr-only">40% Complete (success)</span>
                              </div>
                            </div>
                            <h6>10年以上</h6>
                            <div class="progress pb-sm">
                              <div class="progress-bar progress-bar-yellow" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style="width: 35%">
                                 <span class="sr-only">40% Complete (success)</span>
                              </div>
                            </div>
                        </div>
                        
                        <div class="col-md-4">
                            <div class="block-heading-two">
                                <h3><span>サービス</span></h3>
                            </div>		
                            <!-- Accordion starts -->
                            <div class="panel-group" id="accordion-alt3">
                            <!-- Panel. Use "panel-XXX" class for different colors. Replace "XXX" with color. -->
                              <div class="panel">
                                 <div class="panel-heading">
                                    <h4 class="panel-title">
                                      <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseThree-alt3">
                                        <i class="fa fa-angle-right"></i>職種構成
                                      </a>
                                    </h4>
                                 </div>
                                 <div id="collapseThree-alt3" class="panel-collapse collapse">
                                    <div class="panel-body">
                                      ◆ PM (プロジェクトマネージャー)<br>
                                      ◆ PL (プロジェクトリーダー)<br>
                                      ◆ SE (システムエンジニア)<br>
                                      ◆ PG (プログラマー)<br>
                                      ◆ PT (プログラムテスター)<br>
                                    </div>
                                 </div>
                              </div>
                              <div class="panel">	
                                <!-- Panel heading -->
                                 <div class="panel-heading">
                                    <h4 class="panel-title">
                                      <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseOne-alt3">
                                        <i class="fa fa-angle-right"></i>業務分野
                                      </a>
                                    </h4>
                                 </div>
                                 <div id="collapseOne-alt3" class="panel-collapse collapse">
                                    <!-- Panel body -->
                                    <div class="panel-body">
                                      ◆ 製造業<br>
                                      ◆ エネルギー<br>
                                      ◆ 小売業<br>
                                      ◆ 不動産関連業<br>
                                      ◆ 金融・保険業<br>
                                      ◆ 物流業<br>
                                      ◆ 通信業<br>
                                      ◆ メディア関連<br>
                                      ◆ その他
                                    </div>
                                 </div>
                              </div>
                              <div class="panel">
                                 <div class="panel-heading">
                                    <h4 class="panel-title">
                                      <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseTwo-alt3">
                                        <i class="fa fa-angle-right"></i>保有技術
                                      </a>
                                    </h4>
                                 </div>
                                 <div id="collapseTwo-alt3" class="panel-collapse collapse">
                                    <div class="panel-body">
                                      ◆ Java<br>
                                      ◆ Web系<br>
                                      ◆ SalesForce<br>
                                      ◆ AWS・Azure<br>
                                      ◆ 人工知能<br>
                                      ◆ IoT<br>
                                      ◆ その他
                                    </div>
                                 </div>
                              </div>
                              <div class="panel">
                                 <div class="panel-heading">
                                    <h4 class="panel-title">
                                      <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseFour-alt3">
                                        <i class="fa fa-angle-right"></i>開発段階
                                      </a>
                                    </h4>
                                 </div>
                                 <div id="collapseFour-alt3" class="panel-collapse collapse">
                                    <div class="panel-body">
                                      ◆ 提案・見積<br>
                                      ◆ 要件定義<br>
                                      ◆ 概要・基本設計<br>
                                      ◆ 詳細設計<br>
                                      ◆ 製造<br>
                                      ◆ 単体テスト<br>
                                      ◆ 結合テスト<br>
                                      ◆ システムテスト<br>
                                      ◆ 受入テスト<br>
                                    </div>
                                 </div>
                              </div>
                            </div>
                            <!-- Accordion ends -->
                        </div>
                    </div>
                    <br>
                    </div>
                </div>
            </section>
        <Footer></Footer>
    </div>
</template>

<script>
import Top from "@/components/TopMenu.vue"
import Footer from "@/components/Footer.vue"
export default{
    name: 'Home',
    components: {
        Top,
        Footer
    }
}
</script>
<!-- <script src="../assets/js/jquery.js"></script>
<script src="../assets/js/jquery.easing.1.3.js"></script>
<script src="../assets/js/bootstrap.min.js"></script>
<script src="../assets/js/jquery.fancybox.pack.js"></script>
<script src="../assets/js/jquery.fancybox-media.js"></script>
<script src="../assets/js/portfolio/jquery.quicksand.js"></script>
<script src="../assets/js/portfolio/setting.js"></script>
<script src="../assets/js/jquery.flexslider.js"></script>
<script src="../assets/js/animate.js"></script>
<script src="../assets/js/custom.js"></script>
<script src="../assets/js/owl-carousel/owl.carousel.js"></script>
<script src="../assets/js/easypiechart/easypiechart.min.js"></script>
<script src="../assets/js/nivo-lightbox.js"></script>
<script src="../assets/js/main.js"></script> -->
<!-- <script>
    $(document).ready(function(){
        $(".headerpage").load("header.html");
        $(".footerpage").load("footer.html");
    });
</script> -->
<!--
<script>
    // You can also use "$(window).load(function() {"
    $(function () {
      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager:true,
        nav:true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });
 </script> -->
<!--banner Slider starts Here-->

<style scoped>
</style>